import {
    axiosJwt
} from '@/shared/auth/axios-lib'
import {
    errorHandler
} from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}/administracao`

export default {
    obterTodas() {
        let url = `${api}/dirfs`
        return axiosJwt.get(url)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },


    obterPorId(id) {
        let url = `${api}/dirfs/${id}`
        return axiosJwt.get(url)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterValores(id) {
        let url = `${api}/dirfs/beneficiarios/${id}/valores`
        return axiosJwt.get(url)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterRendimentos(id) {
        let url = `${api}/dirfs/beneficiarios/${id}/rendimentos`
        return axiosJwt.get(url, {
            responseType: 'blob'
        }).then((response) => {
            return response.data
        }).catch((error) => {
            return errorHandler(error)
        })
    },

    obterPagamentos(id) {
        let url = `${api}/dirfs/beneficiarios/${id}/pagamentos`
        return axiosJwt.get(url, {
            responseType: 'blob'
        }).then((response) => {
            return response.data
        }).catch((error) => {
            return errorHandler(error)
        })
    },

    inserirDirf(dirf) {
        let url = `${api}/dirfs`
        const formData = new FormData()
        formData.append('arquivo', dirf.arquivo)
        let promisse = axiosJwt.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        return promisse.then((response) => {
            return response.data
        }).catch((error) => {
            return errorHandler(error)
        })
    }
}
